<script setup lang="ts">
const props = defineProps<{
  title?: string
  placeholder: string
  button: StoryBlokButton[]
  secondaryButton?: StoryBlokButton[]
  mask: { mask: string | RegExp }
  countryCode: string
  text?: StoryBlokRichText
  image?: StoryBlokImage
}>()

const emit = defineEmits(['click'])
const form = ref()
</script>

<template>
  <FormSimple
    ref="form"
    class="w-full bg-white p-5 rounded-xl border-1 border-gray-light relative overflow-hidden"
    @submit="emit('click', form?.values?.licensePlate || 'nospz', 'spz')"
  >
    <h2 v-html="title" />
    <div class="mt-2 items-center md:flex md:justify-start md:gap-2">
      <FormFieldText
        :mask="mask"
        disable-storyblok
        :placeholder="placeholder"
        name="licensePlate"
        class="text-secondary w-full h-full rounded-xl overflow-hidden md:max-w-1/2 focus:outline-none"
      >
        <template #start>
          <div class="bg-[#003399] flex items-center justify-center px-2 py-2.5">
            <div class="flex-col items-center">
              <nuxt-icon name="core/euStars" filled class="text-xs" />
              <div class="text-white text-[12px] pt-0.5">
                {{ props.countryCode }}
              </div>
            </div>
          </div>
        </template>
      </FormFieldText>
      <StoryblokButton submit v-bind="button[0]" class="<md:w-full <md:mt-2" />
    </div>
    <div class="flex justify-between <md:items-end relative">
      <div class="w-full flex flex-col">
        <StoryblokButton v-if="secondaryButton?.length" v-editable="secondaryButton[0]" v-bind="secondaryButton[0]" target="_self" class="whitespace-nowrap" size="small" render="link" />
        <StoryblokRichText :document="text" class="tick-mark-list z-5" />
      </div>
      <StoryblokImage class="<xs:absolute <xs:left-54 <xs:top-20 <xs:w-max-[152px] xs:max-w-[200px] sm:max-w-[260px] xl:max-w-[300px]" :src="image" />
    </div>
  </FormSimple>
</template>
